//#region IMPORTS
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
} from "@heroicons/react/24/outline";
import { Fragment } from "react";
import PaginationBarClientButton from "./PaginationBarClientButton";
//#endregion

//#region INTERFACE
interface Props {
  changePageSizeHandler?: (pageSize: number) => void;
  prevPageAvailable?: boolean;
  nextPageAvailable?: boolean;
  firstPageHandler?: () => void;
  prevPageHandler?: () => void;
  nextPageHandler?: () => void;
  lastPageHandler?: () => void;
  totalAmmount: number;
  currentPage?: number;
  pageCount?: number;
  pageSize?: number;
  disabled?: boolean;
  type?: string;
  hide?: boolean;
}
//#endregion

export default function PaginationBarClient({
  changePageSizeHandler,
  prevPageAvailable = false,
  nextPageAvailable = false,
  firstPageHandler,
  prevPageHandler,
  nextPageHandler,
  lastPageHandler,
  totalAmmount,
  currentPage = 0,
  pageSize = 15,
  pageCount = 0,
  disabled = false,
  type = "items",
  hide = false,
}: Props) {
  //#region RENDER

  if (hide || totalAmmount <= pageSize) return null;

  return (
    <footer className="mt-2 flex items-center justify-between gap-4 text-sm text-gray-500 px-4 sm:px-6 lg:px-8">
      <section className="flex items-center gap-4">
        {firstPageHandler && (
          <PaginationBarClientButton
            needHelpMessage="Go to first page"
            clickHandler={firstPageHandler}
            disabled={disabled || !prevPageAvailable}
          >
            <ArrowUturnLeftIcon className="w-5 h-5" />
          </PaginationBarClientButton>
        )}
        {prevPageHandler && (
          <PaginationBarClientButton
            needHelpMessage="Go to previous page"
            clickHandler={prevPageHandler}
            disabled={disabled || !prevPageAvailable}
          >
            <ArrowLeftIcon className="w-5 h-5" />
          </PaginationBarClientButton>
        )}

        {nextPageHandler && (
          <PaginationBarClientButton
            needHelpMessage="Go to next page"
            clickHandler={nextPageHandler}
            disabled={disabled || !nextPageAvailable}
          >
            <ArrowRightIcon className="w-5 h-5" />
          </PaginationBarClientButton>
        )}

        {lastPageHandler && (
          <PaginationBarClientButton
            needHelpMessage="Go to last page"
            clickHandler={lastPageHandler}
            disabled={disabled || !nextPageAvailable}
          >
            <ArrowUturnRightIcon className="w-5 h-5" />
          </PaginationBarClientButton>
        )}

        <div className="flex items-center gap-1">
          <span>page</span>
          <strong>
            {currentPage} of {pageCount}
          </strong>
        </div>
      </section>

      <section className="flex items-center">
        {changePageSizeHandler ? (
          <Fragment>
            <select
              disabled={disabled}
              className="block border-0 py-1 text-rose-800 ring-0 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
              value={pageSize}
              onChange={(e) => {
                changePageSizeHandler(Number(e.target.value));
              }}
            >
              {[8, 10, 15, 20, 25, 30].map((pageSize) => (
                <option key={pageSize} value={pageSize}>
                  Show {pageSize}
                </option>
              ))}
            </select>
            <span>
              of {totalAmmount} {type}
            </span>
          </Fragment>
        ) : (
          <div>
            {totalAmmount} {type}
          </div>
        )}
      </section>
    </footer>
  );
  //#endregion
}
